import React from "react";
import { motion } from "framer-motion";
import { ClipboardList, ShieldCheck, Rocket } from "lucide-react";
import styles from "../sidequest.module.scss";

const steps = [
  {
    icon: ClipboardList,
    number: "01",
    title: "Submit your details",
    description: "Share your name, work email, and dev handle in the form above.",
  },
  {
    icon: ShieldCheck,
    number: "02",
    title: "We verify you",
    description: "Our team confirms you're part of the Sidequest developer program.",
  },
  {
    icon: Rocket,
    number: "03",
    title: "Access granted",
    description: "Once verified, you're granted access to your plan on KeyQuest.",
  },
];

const HowItWorks = () => {
  return (
    <section className={styles.section}>
      <div className={styles.container}>
        <div className={styles.sectionHeader}>
          <span className={styles.badge}>How It Works</span>
          <h2>Three steps to get started</h2>
          <p>No individual sign-ups needed &mdash; just tell us who you are.</p>
        </div>

        <div className={styles.timeline}>
          {steps.map((step, idx) => {
            const Icon = step.icon;
            const isEven = idx % 2 === 1;
            return (
              <motion.div
                key={step.title}
                className={`${styles.timelineItem} ${isEven ? styles.timelineItemEven : styles.timelineItemOdd}`}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.4, delay: idx * 0.1 }}
              >
                <div className={styles.timelineNumberWrap}>
                  <span className={styles.timelineGhostNumber}>{step.number}</span>
                  <div className={styles.timelineNumber}>
                    <Icon size={22} color="#ff2f6d" />
                  </div>
                </div>
                <div className={styles.timelineContent}>
                  <h3>{step.title}</h3>
                  <p>{step.description}</p>
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
